<template>
  <div class="wrapper__last">
    <div
      class="node-container__last"
      :style="{gridTemplateColumns: titleLength}"
    >
      <div class="primary-horizontal-line__last"></div>
      <div class="primary-arrow-container__last">
        <z-icon
          v-if="lastItem.children && lastItem.children.length"
          class="icon-arrow__last"
          @click="lastItem.open = !lastItem.open"
        >
          {{ lastItem.open ? openedIcon : closedIcon }}
        </z-icon>
        <span class="primary-title__last body-bold">{{ lastItem.title }} </span>
      </div>

      <div class="primary-action__last">
        <slot name="action" :item="lastItem"></slot>
      </div>
    </div>

    <v-expand-transition>
      <template v-if="lastItem.open">
        <div class="secondary-wrapper__last">
          <div v-for="(child, index) in lastItem.children" :key="index">
            <div
              class="secondary-node-container__last"
              :style="{gridTemplateColumns: childTitleLength}"
            >
              <div class="secondary-horizontal-line__last"></div>
              <div class="secondary-arrow-container__last">
                <z-icon
                  v-if="child.children && child.children.length"
                  class="icon-arrow__last"
                  @click="child.open = !child.open"
                >
                  {{ child.open ? openedIcon : closedIcon }}
                </z-icon>
                <span class="body-text secondary-title__last">
                  {{ child.title }}</span
                >
              </div>
              <div class="secondary-action__last">
                <slot
                  name="sub-action"
                  :item="lastItem"
                  :subItem="child"
                ></slot>
              </div>
            </div>

            <v-expand-transition>
              <template v-if="child.open && child.children">
                <div class="tertiary-wrapper__last">
                  <div
                    v-for="(grandChild, secondIndex) in child.children"
                    :key="secondIndex"
                  >
                    <div
                      class="tertiary-node-container__last"
                      :style="{gridTemplateColumns: grandChildTitleLength}"
                    >
                      <div class="tertiary-horizontal-line__last"></div>
                      <div class="tertiary-arrow-container__last">
                        <z-icon
                          v-if="
                            grandChild.children && grandChild.children.length
                          "
                          class="icon-arrow__last"
                        >
                          {{ closedIcon }}
                        </z-icon>
                        <span class="body-text tertiary-title__last">
                          {{ grandChild.title }}</span
                        >
                      </div>
                      <div class="tertiary-action__last">
                        <slot
                          name="sub-sub-action"
                          :item="lastItem"
                          :subItem="child"
                          :grandChild="grandChild"
                        ></slot>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </v-expand-transition>
          </div>
        </div>
      </template>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: 'LastItem',
  props: {
    lastItem: {
      type: Object,
      required: true,
    },
    titleLength: {
      type: String,
      required: false,
    },
    childTitleLength: {
      type: String,
      required: false,
    },
    grandChildTitleLength: {
      type: String,
      required: false,
    },
    openedIcon: {
      type: String,
      required: false,
      default: '$arrow_down',
    },
    closedIcon: {
      type: String,
      required: false,
      default: '$keyboard_arrow_right_rounded',
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper__last {
  position: relative;

  &::before {
    content: '';
    height: 32px;
    position: absolute;
    border-left: dashed 1px #666666;
    left: 0px;
  }
  .node-container__last {
    display: grid;
    align-items: center;
    margin-top: 8px;
    height: 50px;

    .primary-action__last {
      display: flex;
      justify-content: flex-end;
      width: 100%;
    }

    .primary-arrow-container__last {
      display: flex;
      align-items: center;

      .icon-arrow__last {
        height: min-content;
        &::after {
          height: unset !important;
        }
      }
      .primary-title__last {
        margin-left: 5px;
      }
    }
    .primary-horizontal-line__last {
      width: 20px;
      height: 5px;
      border-bottom: dashed 1px #666666;
    }
  }
}

.secondary-wrapper__last {
  position: relative;
  margin-left: 31px;

  &::before {
    content: '';
    height: calc(100% - 17px);
    position: absolute;
    border-left: dashed 1px #666666;
    left: 0px;
  }

  .secondary-node-container__last {
    display: grid;
    align-items: center;
    height: 50px;

    .secondary-arrow-container__last {
      display: flex;
      align-items: center;
    }

    .secondary-title__last {
      margin-left: 5px;
    }

    .secondary-horizontal-line__last {
      width: 28px;
      border-bottom: dashed 1px #666666;
    }
  }
}

.secondary-action__last,
.tertiary-action__last {
  justify-self: flex-end;
}

.tertiary-wrapper__last {
  position: relative;
  margin-left: 40px;

  &::before {
    content: '';
    height: calc(100% - 17px);
    position: absolute;
    border-left: dashed 1px #666666;
    left: 0px;
  }

  .tertiary-node-container__last {
    display: grid;
    align-items: center;
    height: 50px;

    .tertiary-arrow-container__last {
      display: flex;
      align-items: center;

      &.icon-arrow__last {
        height: min-content;
        &::after {
          height: unset !important;
        }
      }
    }

    .tertiary-title__last {
      margin-left: 5px;
    }

    .tertiary-horizontal-line__last {
      width: 28px;
      border-bottom: dashed 1px #666666;
    }
  }
}
</style>
